//region block: pre-declaration
//endregion
function get_VOID() {
  _init_properties_void_kt__3zg9as();
  return VOID;
}
var VOID;
var properties_initialized_void_kt_e4ret2;
function _init_properties_void_kt__3zg9as() {
  if (!properties_initialized_void_kt_e4ret2) {
    properties_initialized_void_kt_e4ret2 = true;
    VOID = void 0;
  }
}
//region block: exports
export {
  VOID as VOID3gxj6tk5isa35,
};
//endregion

//# sourceMappingURL=void.mjs.map
